export function fvAutoScroll() {
  // 767px以下では実行しない
  if (window.matchMedia('(max-width: 767px)').matches) {
    return;
  }

  const bg = document.querySelector('.p-fv_bg');

  if (!bg) return;

  /*
   * ブラウザのスクロール位置復元を無効化
   */
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  /*
   * ロード / リロード時はページトップに戻す
   */
  if (window.lenis) {
    window.lenis.scrollTo(0, {
      immediate: true,
    });
  } else {
    window.scrollTo(0, 0);
  }

  let autoScrollTimer = null;
  let hasUserScrolled = false;


  /*
   * ========================================
   * ユーザーのスクロール操作を検知
   * ========================================
   */
  const scrollKeys = [
    'ArrowUp',
    'ArrowDown',
    'PageUp',
    'PageDown',
    'Home',
    'End',
    ' ',
  ];

  const handleUserScroll = () => {

    /*
     * 一度でも操作されたら
     * 自動スクロールをキャンセル
     */
    hasUserScrolled = true;

    if (autoScrollTimer) {
      clearTimeout(autoScrollTimer);
      autoScrollTimer = null;
    }

    removeScrollDetection();
  };


  const handleKeyScroll = (e) => {
    if (scrollKeys.includes(e.key)) {
      handleUserScroll();
    }
  };


  const addScrollDetection = () => {
    window.addEventListener('wheel', handleUserScroll, {
      passive: true,
    });

    window.addEventListener('touchmove', handleUserScroll, {
      passive: true,
    });

    window.addEventListener('keydown', handleKeyScroll);
  };


  const removeScrollDetection = () => {
    window.removeEventListener('wheel', handleUserScroll);
    window.removeEventListener('touchmove', handleUserScroll);
    window.removeEventListener('keydown', handleKeyScroll);
  };


  /*
   * ========================================
   * 自動スクロール中の操作を停止
   * ========================================
   */
  const preventScroll = (e) => {
    e.preventDefault();
  };


  const preventKeyScroll = (e) => {
    if (scrollKeys.includes(e.key)) {
      e.preventDefault();
    }
  };


  const lockScroll = () => {
    window.addEventListener('wheel', preventScroll, {
      passive: false,
    });

    window.addEventListener('touchmove', preventScroll, {
      passive: false,
    });

    window.addEventListener('keydown', preventKeyScroll);
  };


  const unlockScroll = () => {
    window.removeEventListener('wheel', preventScroll);
    window.removeEventListener('touchmove', preventScroll);
    window.removeEventListener('keydown', preventKeyScroll);
  };


  /*
   * ========================================
   * 自動スクロール
   * ========================================
   */
  const startAutoScroll = () => {

    /*
     * ユーザー操作を監視
     */
    addScrollDetection();


    /*
     * 3秒後に自動スクロール
     */
    autoScrollTimer = setTimeout(() => {

      /*
       * それまでにユーザーがスクロールしていたら
       * 自動スクロールしない
       */
      if (hasUserScrolled) {
        return;
      }


      /*
       * 自動スクロール開始後は
       * ユーザー操作検知は不要
       */
      removeScrollDetection();


      const targetY =
        bg.getBoundingClientRect().top +
        window.scrollY;


      /*
       * 自動スクロール中のみ操作禁止
       */
      lockScroll();


      if (window.lenis) {

        window.lenis.scrollTo(targetY, {

          duration: 1.8,

          /*
           * easeInOutCubic
           */
          easing: (t) =>
            t < 0.5
              ? 4 * t * t * t
              : 1 - Math.pow(-2 * t + 2, 3) / 2,


          onComplete: () => {
            unlockScroll();
          },

        });

      } else {

        window.scrollTo({
          top: targetY,
          behavior: 'smooth',
        });


        setTimeout(() => {
          unlockScroll();
        }, 1800);

      }

    }, 2600);
  };


  startAutoScroll();
}